import { createBrowserRouter, Navigate } from 'react-router-dom'
import Layout from '@/components/Layout'
import Trade from '@/views/Trade'
import Wallet from '@/views/Wallet'
import WalletHistory from '@/views/WalletHistory'
import Account from '@/views/Account'
import Markets from '@/views/Markets'
import Orders from '@/views/Orders'
import NotFound from '@/views/NotFound'
import { DEFAULT_ROUTE_MAP } from '@/constants/config'

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Navigate to={DEFAULT_ROUTE_MAP.trade} replace />
      },
      {
        path: 'account',
        element: <Account />
      },
      {
        path: 'markets',
        element: <Markets />
      },
      {
        path: 'orders',
        element: <Orders />
      },
      {
        path: 'trade/:marketSymbol?',
        element: <Trade />
      },
      {
        path: 'wallet',
        element: <Wallet />
      },
      {
        path: 'wallet/history',
        element: <Navigate to={DEFAULT_ROUTE_MAP.walletHistory} replace />
      },
      {
        path: 'wallet/history/:type',
        element: <WalletHistory />
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
])

export default router
